export type Gender = 'male' | 'female';
/** `klijent` = naručitelj s računom (backend `KUPAC`, K5); u dashboard ne ulazi, njegov prostor je `/racun`. */
export type UserRole = 'candidate' | 'employer' | 'admin' | 'subadmin' | 'klijent';


interface BaseProfile {
  name: string;
  email: string;
  phone: string;
  gender: Gender;
}

export interface CandidateProfile extends BaseProfile {
  role: 'candidate';
  experience: string;
  education: string;
  licenses: string[];
  availability: string;
  address?: string;
  // Profilni CV (zaseban od per-prijava CV-a). Optional jer stari localStorage
  // profili nemaju ova polja dok ih sljedeći /my-profile fetch ne rehidrira.
  hasCv?: boolean;
  cvFileName?: string | null;
  cvUploadedAt?: string | null;
  // Optional iz istog razloga kao CV polja. Server-side se resetira na false
  // pri promjeni broja kroz PUT /my-profile.
  phoneVerified?: boolean;
}


export interface CompanyUserProfile extends BaseProfile {
  role: 'employer' | 'admin' | 'subadmin';
  companyId: number | null;   // employer praktički uvijek ima; admin može biti bez primarne firme
  companyName: string;
}

/** K5: klijent s računom. Ime, e-mail i broj; firme nema. */
export interface KlijentProfile extends BaseProfile {
  role: 'klijent';
}

export type UserProfile = CandidateProfile | CompanyUserProfile | KlijentProfile;

/** Korisnik firme (izvođač, admin, subadmin): jedini s firmom i dashboardom. */
export function jeKorisnikFirme(u: UserProfile): u is CompanyUserProfile {
  return u.role === 'employer' || u.role === 'admin' || u.role === 'subadmin';
}